import React, { useState, useEffect } from 'react';

import Dropdown from 'react-bootstrap/Dropdown';
import DropdownToggle from '../../../presentation/dropdown/DropdownToggle';
import DropdownMenu from '../../../presentation/dropdown/DropdownMenu';
import CheckboxForm from '../../../presentation/checkbox/CheckboxForm';

import './NoiseFilteringDropdown.css'

const NoiseFilteringDropdown = (props) => {
  const dropdownName = '노이즈 필터링 ▼';

  const [filterArray, setFilterArray] = useState([...Array((props.noiseFilteringData).length)].map(x => false));
  useEffect(() => {
    setFilterArray([...Array((props.noiseFilteringData).length)].map(x => false))
  }, [props.noiseFilteringData])

  const handleDropdownBtn = (queryType, getString, filteringData, filterArray) => {
    props.handleCreateBtn(queryType, getString(queryType, filteringData, filterArray));
  }

  const handleClickCheckbox = (checkboxIndex, value) => {
    setFilterArray(
      filterArray.map((item, index) => index === checkboxIndex ? value : item)
    )
  }

  const getCheckedFilterString = (queryType, filteringData, filterArray) => {
    let checkedFilterString = '';
    filterArray.forEach((item, index) => {
      if (item) {
        if (queryType == 'basicQuery') {
          checkedFilterString = `${checkedFilterString} ${filteringData[index].basicFilterString}`
        }
        else if (queryType == 'booleanQuery') {
          checkedFilterString = `${checkedFilterString} ${filteringData[index].booleanFilterString}`
        }
      }
    })
    return checkedFilterString;
  }

  return (
    <Dropdown className="noiseSelectBox" id="select">
      <Dropdown.Toggle hrefValue="" as={DropdownToggle} id="dropdown-custom-components">
        {dropdownName}
      </Dropdown.Toggle>
      <Dropdown.Menu as={DropdownMenu} >
        {/* <div style={{marginBottom: "10px"}}> */}
        <div>
          {props.noiseFilteringData.map((item, index) => (
            <CheckboxForm key={`noise-filtering-checkbox-${index}`} label={item.category} id={item.id} index={index} onClick={handleClickCheckbox} />
          ))}
        </div>
        <Dropdown.ItemText className="noiseOptionSettingBtn">
          <Dropdown.Item style={{ width: "auto" }} className="button purple_line" onClick={() => handleDropdownBtn('basicQuery', getCheckedFilterString, props.noiseFilteringData, filterArray)}>
            Basic
          </Dropdown.Item>
          &nbsp;&nbsp;
          <Dropdown.Item style={{ width: "auto" }} className="button purple_line" onClick={() => handleDropdownBtn('booleanQuery', getCheckedFilterString, props.noiseFilteringData, filterArray)}>
            Boolean
          </Dropdown.Item>
        </Dropdown.ItemText>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default NoiseFilteringDropdown;

